export default __webpack_public_path__ + "static/media/flayer22.ba4ffe75.jpg";